import i18n from '@/services/i18n'

export default [
  { key: 'SEARCH', value: i18n.t("searches") },
  { key: 'SEEN', value: i18n.t("tabs.youtube.seen") }
]